"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_chartjs_2_1 = require("react-chartjs-2");
var react_redux_1 = require("react-redux");
var statisticsSlice_1 = require("../../features/statistics/statisticsSlice");
var deviceHelper_1 = require("../../helpers/deviceHelper");
var react_i18next_1 = require("react-i18next");
var chartOptions_1 = __importDefault(require("./chartOptions"));
var ChartLoader_1 = __importDefault(require("../ChartLoader"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
function reducer(state, action) {
    if (action.type === 'totalViews') {
        return __assign(__assign({}, state), { scales: {
                x: __assign({}, state.scales.x),
                y: __assign(__assign({}, state.scales.y), { max: action.payload.totalViews }),
            } });
    }
    if (action.type === 'initialOptions') {
        return action.payload.options;
    }
    return state;
}
var StatisticsChart = function (_a) {
    var totalViews = _a.totalViews;
    var _b = react_1.useReducer(reducer, chartOptions_1.default), cartOptions = _b[0], dispatch = _b[1];
    var statisticsData = react_redux_1.useSelector(statisticsSlice_1.statistics);
    var statisticsLoader = react_redux_1.useSelector(statisticsSlice_1.statisticsLoadingSelector);
    var _c = react_1.useState(), emptyChart = _c[0], setEmptyChart = _c[1];
    var t = react_i18next_1.useTranslation('common').t;
    var translateLabels = function (data) {
        data.labels = data.labels.map(function (label) {
            return deviceHelper_1.isMobile()
                ? t("DATE_UNIT_SHORT_NAME." + label)
                : t("DATE_UNIT_NAME." + label);
        });
        return data;
    };
    var deleteStatisticsData = function (data) {
        data.datasets[0].data = data.datasets[0].data.map(function () { return 0; });
        setEmptyChart(data);
    };
    react_1.useEffect(function () {
        if (totalViews > 0) {
            dispatch({
                type: 'totalViews',
                payload: {
                    totalViews: totalViews,
                },
            });
        }
        else {
            dispatch({
                type: 'initialOptions',
                payload: {
                    options: chartOptions_1.default,
                },
            });
        }
    }, [totalViews]);
    react_1.useEffect(function () {
        deleteStatisticsData(translateLabels(statisticsData));
        dispatch({
            type: 'initialOptions',
            payload: {
                options: chartOptions_1.default,
            },
        });
    }, [statisticsLoader]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.statistics_chart }, statisticsLoader ? (react_1.default.createElement(ChartLoader_1.default, null)) : (react_1.default.createElement(react_chartjs_2_1.Bar, { data: translateLabels(statisticsData), height: deviceHelper_1.isMobile() ? 140 : 80, options: cartOptions })))));
};
exports.default = StatisticsChart;
